// ============================================
// FILE: src/App.jsx
// ============================================
import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Navbar from './components/Navbar';
import Footer from './components/Footer';
import HomePage from './pages/HomePage';
import RentPage from './pages/RentPage';
import SalePage from './pages/SalePage';
import BuyPage from './pages/BuyPage';
import AgreementsPage from './pages/AgreementsPage';
import DocumentsPage from './pages/DocumentsPage';

import InquiryPage from './pages/InquiryPage';
import ScrollToTop from './components/ScrollToTop';
import InteriorDesignPage from './pages/InteriorDesignPage';
import HomeLoanPage from './pages/Homeloan';
import PropertyDetailsPage from './pages/Propertydetailspage';

function App() {
  return (
   
    <Router>
        <ScrollToTop /> 
      <div className="min-h-screen flex flex-col">
        <Navbar />
        <main className="flex-grow">
          <Routes>
            <Route path="/" element={<HomePage />} />
            <Route path="/rent" element={<RentPage />} />
            <Route path="/sale" element={<SalePage />} />
            <Route path="/buy" element={<BuyPage />} />
            <Route path="/agreements" element={<AgreementsPage />} />
            <Route path="/documents" element={<DocumentsPage />} />
           
      
            <Route path="/inquiry" element={<InquiryPage />} />
            <Route path="/interior" element={<InteriorDesignPage />} />
             <Route path="/home-loan" element={<HomeLoanPage/>} />
             <Route path="/property/:id" element={<PropertyDetailsPage />} />
          </Routes>
        </main>
        <Footer />
      </div>
    </Router>
  );
}

export default App;